import { render, staticRenderFns } from "./CustomerService.vue?vue&type=template&id=f7e019fc&scoped=true&"
import script from "./CustomerService.vue?vue&type=script&lang=js&"
export * from "./CustomerService.vue?vue&type=script&lang=js&"
import style0 from "./CustomerService.vue?vue&type=style&index=0&id=f7e019fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e019fc",
  null
  
)

export default component.exports